import { formatDurationToUnit, getDefaultUnit } from 'customer-data-filters-ui/utils/durationUtilities';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueDuration = props => {
  const {
    value: duration
  } = props;
  const unit = getDefaultUnit(duration);
  const formattedDuration = formatDurationToUnit(duration, unit);
  const langKey = 'customerDataFiltersUI.customerDataFilters.FilterOperatorDurationInput.DurationUnits.countAndUnit';
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${langKey}.${unit}`,
    options: {
      count: formattedDuration
    }
  });
};
export default /*#__PURE__*/memo(DisplayValueDuration);